import './App.css';
import Login from "./Pages/Login/Login";
import Home from "./Pages/Main/Main";
import "./Components/ToastNotification/ToastNotification.css";
import { useEffect, useState } from 'react';
import { RefreshToken } from './Services/Api/AuthRequests';
import ToastNotification from './Components/ToastNotification/ToastNotification';
import { InitToastManager } from './Services/ToastNotification/ToastNotificationManager';

function App() {
  //Toast Manager
  const [toastNotifications, setToastNotifications] = useState([]);
  const [refresh, setRefresh] = useState("");
  InitToastManager(setToastNotifications, setRefresh);

  const [logged, setLogged] = useState(false);

  const onTokenRefereshed = () => {
    setLogged(true);
  } 

  const onTokenFailedToRefresh = () => {
    setLogged(false);
  }

  useEffect(() => {
    RefreshToken(onTokenRefereshed, onTokenFailedToRefresh);
    
    const tokenRefresh = setInterval(() => {
      RefreshToken(onTokenRefereshed, onTokenFailedToRefresh);
    }, 20000)

    return () => { clearInterval(tokenRefresh) }
  }, [])


  return (
      <div className="App">
        {  !logged &&
          <Login setLogged={setLogged} />
        }
        { logged &&
          <Home />
        }
        <div className='toastNotificationsContainer'>
          { toastNotifications.map((info, index) =>
            <ToastNotification key={"toastNotification_" + index} text={info.text} index={index} type={info.type}/>
          )}
        </div>
      </div>
  );
}

export default App;
